<div style="display: flex; justify-content: center; align-items: center; flex-direction: column;">
    <div class="overdiv">
        <div>
            <h1>{{dataJson["Ueberschrift"]}}</h1>
            <span>{{dataJson["Block1Text1"]}}</span> <br> <br>
            <span>{{dataJson["Block1Text2"]}}</span><br><br>
            <span>{{dataJson["Block1Text3"]}}</span>
        </div>
        <div style="margin-top: 20px;">
            <h3><span style="font-weight: 400; ">{{dataJson["Block2Ueberschrift"]}}</span></h3>
            <span>{{dataJson["Block2Text1"]}}</span>
        </div>
        <div style="margin-top: 20px;">
            <h3><span style="font-weight: 400;">{{dataJson["Block3Ueberschrift"]}}</span></h3>
            <span>{{dataJson["Block3Text1"]}}</span> <br><br>
            <span>{{dataJson["Block3Text2"]}}</span>
        </div>
        <div style="margin-top: 20px;">
            <h3><span style="font-weight: 400; ">{{dataJson["block4Ueberschrift"]}}</span></h3>
            <span>{{dataJson["Block4Text1"]}}</span>
        </div>
        <div style="margin-top: 20px;">
            <h3><span style="font-weight: 400; ">{{dataJson["block5Ueberschrift"]}}</span></h3>
            <span>{{dataJson["Block5Text1"]}}</span> <br><br>
            <span>{{dataJson["Block5Text2"]}}</span>
        </div>
        <div style="margin-top: 20px;">
            <h3><span style="font-weight: 400; ">{{dataJson["Block6Ueberschrift"]}}</span></h3>
            <span>{{dataJson["Block6Text1"]}}</span> <br><br>
            <span>{{dataJson["Block6Text2"]}}</span>
        </div>
        <div style="margin-top: 20px;">
            <h3><span style="font-weight: 400; ">{{dataJson["Block7Ueberschrift"]}}</span></h3>
            <span>{{dataJson["Block7Text1"]}}</span>
        </div>
        <div style="margin-top: 20px;">
            <h3><span style="font-weight: 400; ">{{dataJson["Block8Ueberschrift"]}}</span></h3>
            <span>{{dataJson["Block8Text1"]}}</span> <br><br>
            <span>{{dataJson["Block7Text2"]}}</span>
        </div>
    </div>


<app-contact-pre></app-contact-pre>
<a aria-label="Zurück-Button" class="backbutton" routerLink="/leistungen"> < </a>
</div>
